
import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';

import styles from './LogOrRegPagePop.module.css';
import pageStylePops from './pageStylePops.module.css';

import SwiperSection from '../ForAllComponents/SwiperSection';
import ConnUrls from '../Connections/ConnectURL';
import {
    theMenuItems
} from '../FAKEDB/fakes'
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import utilsSpecialPages from '../Connections/_Utils/utilsSpecialPages';
import PopUpClearComp from './PopUpClearComp';
import ConnectPop from './ConnectPop';
import RegisterPagePop from './RegisterPagePop';

const NoOrdersPop = (props) => {

    const navigate = useNavigate();
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : styles);
    const [pageDetails, setPageDetails] = useState();
    const [thePopUp, setThePopUp] = useState();

    useEffect(() => {
    }, [mobiOrNot]);

    useEffect(() => {


    }, [])

    useEffect(() => {
        const getPageDetalis = async () => {
            let pg = await utilsSpecialPages.getStaticPageByName("noOrdersForNow")
            setPageDetails(pg);
        }
        getPageDetalis();
    }, [])

  

    return (
        <div className={`${pageStylePops.topPlace} regularPoint`}>
            {pageDetails && <>
                <div className={pageStylePops.topPlaceWrap}>
                    <div className={pageStylePops.TopImg}>
                        <img src={`${ConnUrls.servMediasUrl}${!mobiOrNot ? pageDetails.PageTopImage : pageDetails.PageTopImageMobi}`}
                            className={pageStylePops.TopImg} alt={pageDetails.pageName || "אין הזמנות"} />
                        <div className={pageStylePops.halfCircle}></div>
                    </div>
                </div>
                <div className={pageStylePops.contentPlaceWrap}>
                    <div className={pageStylePops.mainTextHead}>
                        {
                            props.heads.map((txt, index) => {
                                return (

                                    <span key={index} className={`${index % 2 !== 0 ? pageStylePops.gold : pageStylePops.blue} bold`}>{txt}
                                        <br />
                                    </span>
                                )
                            })}
                    </div>
                 
                </div>
            </>
            }
            {thePopUp}
        </div >


    );
}

export default NoOrdersPop;
